module.exports = __webpack_public_path__ + "img/grieg_Sosialpolitikk_og_kulturradikalisme1.b3335e03.jpg";